import { IMAGE_HOTSPOT_API, ImageHotspotAPI, ImageHotspotGetRequest } from './image-hotspot-api.js'
import {
  defaultProduct,
  ExternalImageHotspotProduct,
  ExternalImageHotspotProductModel,
  ImageHotspotProduct
} from './typing/product-types.js'
import typia from 'typia'
import { FAKE, inject, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { createSignal } from '@cloudsuite/mosaic-shared/scripts/signals.js'

export const IMAGE_HOTSPOT_STORE = Symbol('IMAGE_HOTSPOT_STORE')

@registerDependency(REAL, IMAGE_HOTSPOT_STORE)
@registerDependency(FAKE, IMAGE_HOTSPOT_STORE)
export class ImageHotspotStore {

  @inject(IMAGE_HOTSPOT_API)
  api!: ImageHotspotAPI

  product: () => ImageHotspotProduct
  private setProduct: (value: ImageHotspotProduct) => void

  private productList: Map<string, ImageHotspotProduct> = new Map()

  constructor() {
    [this.product, this.setProduct] = createSignal<ImageHotspotProduct>(defaultProduct)
  }

  async setOrFetchProduct(productEndpoint: string) {
    const productFound = this.productList.get(productEndpoint)
    if (productFound) {
      this.setProduct(productFound)
    } else {
      const product = await this.fetchProduct(productEndpoint)

      if (product) {
        this.setProduct(product)
        this.productList.set(productEndpoint, product)
      }
    }
  }

  fetchProduct = async (productEndpoint: string) => {
    const newProduct: ExternalImageHotspotProduct = await this.api.getProduct(
      new ImageHotspotGetRequest(productEndpoint)
    )

    if (typia.is<ExternalImageHotspotProduct>(newProduct)) {
      return new ExternalImageHotspotProductModel()
        .with(newProduct)
        .parseToInternalRepresentation()
    } else {
      console.error(`Could not parse data from ${productEndpoint}`)
      return null
    }
  }
}
